import React from 'react';
import MarketingShell from '../../components/MarketingShell';

export default function MoneyBackGuaranteePage() {
  return (
    <MarketingShell title="100% money-back guarantee" description="Last updated August 10, 2025">
      <div className="space-y-4 rounded-xl border border-gray-100 bg-white p-6 text-sm text-gray-600">
        <p>
          If you are not satisfied with Upgraded, you are protected in two ways:
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>7-day guarantee — full refund, no questions asked, within the first 7 days.</li>
          <li>
            Funding guarantee — if you waive the 7-day window, protection continues until we deliver your Grants
            &amp; Value Roadmap with at least $105,000/year in actionable grant and funding opportunities.
          </li>
        </ul>
        <p>Request a refund in your Slack channel or email hello@getupgraded.ai.</p>
        <p>Upgraded Technologies Inc., 2631 W 2nd Ave., Vancouver, BC, V6K 1K1, Canada.</p>
      </div>
    </MarketingShell>
  );
}
